import { Button } from '@eventbrite/eds-button';
import { Modal } from '@eventbrite/eds-modal';
import React, { useEffect, useState } from 'react';
import {
    reloadOnCloseSecondStep,
    trackOnClose,
    trackOnOpen,
} from '../constants/ActivationTrialModal';
import './ActivationModal.scss';
import { TrialFlow } from './TrialFlow';
import { ActivationTrialModalProps, TrialFlowProps } from './types';

export const ActivationTrialModal: React.FC<
    ActivationTrialModalProps & TrialFlowProps
> = ({
    openModal,
    onCloseModal,
    amplitudeSource,
    showButton,
    buttonStyle,
    buttonContainerClassName,
    buttonText,
    setOpenBoostSubscriptionModal,
    ...trialFlowProps
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(openModal);
    const [showSecondStep, setShowSecondStep] = useState<boolean>(false);

    useEffect(() => {
        setIsOpen(openModal);
    }, [openModal]);

    useEffect(() => {
        if (trialFlowProps.trialVersion && isOpen) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'track',
                eventName: 'Boost Trial Modal Viewed',
                eventData: {
                    trialVersion: trialFlowProps.trialVersion,
                },
                sendToHeap: true,
            });
        }
    }, [isOpen, trialFlowProps.trialVersion]);

    const closeModal = (showSecondStep: boolean) => {
        onCloseModal?.();
        trackOnClose(showSecondStep);
        setIsOpen(false);
        reloadOnCloseSecondStep(showSecondStep);
        setOpenBoostSubscriptionModal?.(false);
    };
    const handleOpenModal = () => {
        trackOnOpen(amplitudeSource);
        setIsOpen(true);
    };

    return (
        <>
            {showButton && (
                <Button
                    style={buttonStyle}
                    onClick={() => handleOpenModal()}
                    id="open-modal-button"
                    __containerClassName={buttonContainerClassName}
                >
                    {buttonText}
                </Button>
            )}
            <div
                className={
                    'boost-activation-modal ' +
                    (trialFlowProps.trialVersion || '')
                }
            >
                <Modal
                    isShown={isOpen}
                    onClose={() => closeModal?.(showSecondStep)}
                    noPadding
                >
                    <TrialFlow
                        onCloseModal={closeModal}
                        setShowSecondStep={setShowSecondStep}
                        {...trialFlowProps}
                    />
                </Modal>
            </div>
        </>
    );
};

ActivationTrialModal.defaultProps = {
    buttonText: 'Start your free trial',
    buttonStyle: 'fill',
    openModal: false,
    showButton: true,
} as Partial<ActivationTrialModalProps>;
